import { PageKey } from "@apis:ui_branding/ui_branding";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PAGE_KEYS, PRESET_ICONS } from "./constants";
import { getPageLabel } from "./utils";

interface PageTabsProps {
  activePage: PageKey;
  onPageChange: (page: PageKey) => void;
}

export const PageTabs = ({ activePage, onPageChange }: PageTabsProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        mb: 2,
      }}
    >
      {PAGE_KEYS.map((page) => {
        const isActive = activePage === page;
        return (
          <Button
            key={page}
            onClick={() => onPageChange(page)}
            sx={{
              flex: 1,
              py: 1,
              border: "2px solid",
              borderColor: isActive ? "primary.main" : "transparent",
              bgcolor: isActive ? "white" : "grey.100",
              borderRadius: 2,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.75,
              boxShadow: isActive
                ? "0 2px 8px rgba(31, 173, 178, 0.15)"
                : "none",
              "&:hover": {
                bgcolor: isActive ? "white" : "grey.200",
              },
            }}
          >
            <SVGInternalIcon
              icon={PRESET_ICONS[page][0]?.key as any}
              sx={{
                width: 18,
                height: 18,
                color: isActive ? "primary.main" : "text.secondary",
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.75rem",
                textTransform: "none",
                fontWeight: 500,
                color: isActive ? "primary.main" : "text.secondary",
              }}
            >
              {getPageLabel(page, t)}
            </Typography>
          </Button>
        );
      })}
    </Box>
  );
};
